import { client } from '../http';

export default {
  async getTimeLimitedOffers() {
    const response = await client.get('/api/time-limited-offers/');
    return response.data;
  },
  async deleteTimeLimitedOffer(offerId) {
    const response = await client.delete(`/api/time-limited-offers/${offerId}`);
    return response.data;
  },
};
